import SystemPreloadNew from './protos_file/SystemPreloadNew.pb';
import unfollow from './protos_file/unfollow.pb';
import followAdd from './protos_file/follow.pb';
import ProfileGet from './protos_file/profileGet.pb';

const PB_MAP =  new Map([
    [
        '/follow/user/add/encry',
        {
            pack: followAdd.Follow.UserAdd
        }
    ],
    [
        '/follow/user/unfollow/encry',
        {
            pack: unfollow.Follow.UserUnfollow
        }
    ],
    [
        '/system/preload/new',
        {
            pack: SystemPreloadNew.System.Preload.New
        }
    ],
    [
        '/profile/get/env1',
        {
            pack: ProfileGet.Profile.Get
        }
    ]
]);

// 返回转换pb函数
export const getPbFun = (api) => {
    let { pack, Request, decode } = PB_MAP.get(api) || {};
    try {
        decode = decode || (pack.Response && pack.Response.decode) || ((res) => { return res });
        Request = Request || pack.Request;
    } catch(e) {
        console.log(e, 'getPbFun')
    }
    return {
        decode,
        Request
    };
}


// WEBPACK FOOTER //
// ./js/pb_map/index.js